'use client'

import { useEffect } from 'react'

const CLERK_FAPI_ERROR_PATTERN = 'Object Not Found Matching Id'

/**
 * Suppresses Clerk's raw-string promise rejections (e.g. expired sign-in
 * tokens) that escape app-level try/catch, so they don't surface as P1s in Sentry.
 */
export function UnhandledRejectionHandler() {
  useEffect(() => {
    const handler = (event: PromiseRejectionEvent) => {
      if (
        typeof event.reason === 'string' &&
        event.reason.includes(CLERK_FAPI_ERROR_PATTERN)
      ) {
        event.preventDefault()
        console.warn('[Clerk] Suppressed unhandled rejection:', event.reason)
      }
    }

    window.addEventListener('unhandledrejection', handler)
    return () => {
      window.removeEventListener('unhandledrejection', handler)
    }
  }, [])

  return null
}
